import { Game } from "../../game.js";
import { AbstractOverlay } from "./abstract_overlay.js";
import { OverlayId } from "./overlay_ids.js";
import { OverlayManager } from "./overlay_manager.js";
import { LeaderboardInfoOverlay } from "./overlays/leaderboard_info_overlay.js";
import { GameResultOverlay } from "./overlays/game_result_overlay.js";
import { ContinueOverlay } from "./overlays/continue_overlay.js";
import { NewGoalOverlay } from "./overlays/new_goal_overlay.js";
import { ShopOverlay } from "./overlays/shop_overlay.js";
import { NewBoosterOverlay } from "./overlays/new_booster_overlay.js";
import { InfiniteLivesOverlay } from "./overlays/infinite_lives_overlay.js";
import { DailyCardRewardOverlay } from "./overlays/daily_card_reward_overlay.js";
import { FriendsInfoOverlay } from "./overlays/friends_info_overlay.js";
import { LevelBoxOpenOverlay } from "./overlays/level_box_open_overlay.js";
import { ReturnGiftOverlay } from "./overlays/return_gift_overlay.js";
import { FirstStepsOverlay } from "./overlays/first_steps_overlay.js";
import { FirstStepsChestOverlay } from "./overlays/first_steps_chest_overlay.js";
import { WheelOfFortuneOverlay } from "./overlays/wheel_of_fortune_overlay.js";
import { ConveyorResultOverlay } from "./overlays/conveyor_result_overlay.js";
import { ConveyorTutorialOverlay } from "./overlays/conveyor_tutorial_overlay.js";
import { HappyFallWaitOverlay } from "./overlays/happy_fall_wait_overlay.js";
import { HappyFallResultOverlay } from "./overlays/happy_fall_result_overlay.js";

export class OverlayFactory
{
  public static openOverlay( overlayId: OverlayId, params?: any ): AbstractOverlay | null
  {
    const overlay = this.createOverlay( overlayId, params );
    if ( overlay )
    {
      OverlayManager.openOverlay( overlay );
    } else
    {
      console.warn( `OverlayFactory: Unknown overlay ID: ${overlayId}` );
    }

    return overlay;
  }

  private static createOverlay( overlayId: OverlayId, params?: any ): AbstractOverlay | null
  {
    switch ( overlayId )
    {
      case OverlayId.NONE:
        return null;

      case OverlayId.LEADERBOARD_INFO_OVERLAY:
        return new LeaderboardInfoOverlay(
          OverlayManager.ctx,
          Game.safeAreaLeft(),
          Game.safeAreaTop(),
          Game.getContentWidth(),
          Game.getContentHeight(),
          params,
          overlayId
        );

      case OverlayId.GAME_RESULT_OVERLAY:
        return new GameResultOverlay(
          OverlayManager.ctx,
          Game.safeAreaLeft(),
          Game.safeAreaTop(),
          Game.getContentWidth(),
          Game.getContentHeight(),
          params,
          overlayId
        );

      case OverlayId.CONVEYOR_RESULT_OVERLAY:
        return new ConveyorResultOverlay(
          OverlayManager.ctx,
          Game.safeAreaLeft(),
          Game.safeAreaTop(),
          Game.getContentWidth(),
          Game.getContentHeight(),
          params,
          overlayId
        );

      case OverlayId.CONVEYOR_TUTORIAL_OVERLAY:
        return new ConveyorTutorialOverlay(
          OverlayManager.ctx,
          Game.safeAreaLeft(),
          Game.safeAreaTop(),
          Game.getContentWidth(),
          Game.getContentHeight(),
          params,
          overlayId
        );

      case OverlayId.HAPPY_FALL_RESULT_OVERLAY:
        return new HappyFallResultOverlay(
          OverlayManager.ctx,
          Game.safeAreaLeft(),
          Game.safeAreaTop(),
          Game.getContentWidth(),
          Game.getContentHeight(),
          params,
          overlayId
        );

      case OverlayId.HAPPY_FALL_WAIT_OVERLAY:
        return new HappyFallWaitOverlay(
          OverlayManager.ctx,
          Game.safeAreaLeft(),
          Game.safeAreaTop(),
          Game.getContentWidth(),
          Game.getContentHeight(),
          params,
          overlayId
        );

      case OverlayId.CONTINUE_OVERLAY:
        return new ContinueOverlay(
          OverlayManager.ctx,
          Game.safeAreaLeft(),
          Game.safeAreaTop(),
          Game.getContentWidth(),
          Game.getContentHeight(),
          params,
          overlayId
        );

      case OverlayId.NEW_GOAL_OVERLAY:
        return new NewGoalOverlay(
          OverlayManager.ctx,
          Game.safeAreaLeft(),
          Game.safeAreaTop(),
          Game.getContentWidth(),
          Game.getContentHeight(),
          params,
          overlayId
        );

      case OverlayId.NEW_BOOSTER_OVERLAY:
        return new NewBoosterOverlay(
          OverlayManager.ctx,
          Game.safeAreaLeft(),
          Game.safeAreaTop(),
          Game.getContentWidth(),
          Game.getContentHeight(),
          params,
          overlayId
        );

      case OverlayId.INFINITE_LIVES_OVERLAY:
        return new InfiniteLivesOverlay(
          OverlayManager.ctx,
          Game.safeAreaLeft(),
          Game.safeAreaTop(),
          Game.getContentWidth(),
          Game.getContentHeight(),
          params,
          overlayId
        );

      case OverlayId.SHOP_OVERLAY:
        return new ShopOverlay(
          OverlayManager.ctx,
          Game.safeAreaLeft(),
          Game.safeAreaTop(),
          Game.getContentWidth(),
          Game.getContentHeight(),
          params,
          overlayId
        );


      case OverlayId.FIRST_STEPS_CHEST_OVERLAY:
        return new FirstStepsChestOverlay(
          OverlayManager.ctx,
          Game.safeAreaLeft(),
          Game.safeAreaTop(),
          Game.getContentWidth(),
          Game.getContentHeight(),
          params,
          overlayId
        );

      case OverlayId.FIRST_STEPS_OVERLAY:
        return new FirstStepsOverlay(
          OverlayManager.ctx,
          Game.safeAreaLeft(),
          Game.safeAreaTop(),
          Game.getContentWidth(),
          Game.getContentHeight(),
          params,
          overlayId
        );

      case OverlayId.RETURN_GIFT_OVERLAY:
        return new ReturnGiftOverlay(
          OverlayManager.ctx,
          Game.safeAreaLeft(),
          Game.safeAreaTop(),
          Game.getContentWidth(),
          Game.getContentHeight(),
          params,
          overlayId
        );

      case OverlayId.LEVEL_BOX_OPEN_OVERLAY:
        return new LevelBoxOpenOverlay(
          OverlayManager.ctx,
          Game.safeAreaLeft(),
          Game.safeAreaTop(),
          Game.getContentWidth(),
          Game.getContentHeight(),
          params,
          overlayId
        );

      case OverlayId.WHEEL_OF_FORTUNE_OVERLAY:
        return new WheelOfFortuneOverlay(
          OverlayManager.ctx,
          Game.safeAreaLeft(),
          Game.safeAreaTop(),
          Game.getContentWidth(),
          Game.getContentHeight(),
          params,
          overlayId
        );

      case OverlayId.FRIENDS_INFO_OVERLAY:
        return new FriendsInfoOverlay(
          OverlayManager.ctx,
          Game.safeAreaLeft(),
          Game.safeAreaTop(),
          Game.getContentWidth(),
          Game.getContentHeight(),
          params,
          overlayId
        );


      case OverlayId.DAILY_CARD_REWARD_OVERLAY:
        return new DailyCardRewardOverlay(
          OverlayManager.ctx,
          Game.safeAreaLeft(),
          Game.safeAreaTop(),
          Game.getContentWidth(),
          Game.getContentHeight(),
          params,
          overlayId
      )

      default:
        return null;
    }
  }

  public static isOverlayOpen( overlayId?: OverlayId ): boolean
  {
    return OverlayManager.isAnyOverlayOpened();
  }
}
